module.exports = __webpack_public_path__ + "static/img/VCG41N1020863554.ff0f92b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/planandprepare/images/VCG41N1020863554.png
// module id = yQm4
// module chunks = 0